import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { getUserSession } from "../../../core/util/core/Session";
import sleep from "sleep-promise";

function Form() {
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const session = getUserSession();

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/companies/save`,
        endpointGetById: `${endpointBackend}gci/companies/getById`,
        urlGoBack: `/gci/companies/list`,
        pathView: `/gci/companies/view`
    }

    const labels = {
        labelTitleAdd: "Nova Empresa",
        labelTitleEdit: "Editar Empresa",
        labelTitleView: 'Visualizar Empresa'
    }

    let hiddenValues = {
        core_application_id: session.user.application_id
    };

    const getForm = (values) => {

        let form = {
            hiddenValues,
            fields: [
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome da Empresa',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'phone',
                    type: 'phone',
                    label: 'Telefone',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'photo',
                    type: 'file',
                    label: 'Foto/Logo',
                    uploadPath: '/companies/photos/',
                    extensionAccept: '.jpeg,.jpg,.png',
                    limitFileSize: 5,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'organization_type',
                    type: 'select',
                    label: 'Tipo de Organização',
                    options: [
                        { label: 'Incorporadora', value: 'default' },
                        { label: 'Terceiro Setor', value: 'third_sector' }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels,
        }

        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
                hiddenValues.core_application_instance_id = values.core_application_instance_id;
            }
            
            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}

export default Form;
